/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import type { NgGenericTask } from '@karya/core';
import type { ComponentNode, TaskExecutionController } from '@karya/generic-task-react';
import { UserComponentRendererConfig } from '../chakra/user/Index';
import type { ComponentRendererProps } from '../chakra/shared/Types';
import { UnsupportedComponentRenderer } from './UnsupportedComponentRenderer';
import { SubmitTaskButton } from '../chakra/shared/SubmitTaskButton';
import { VStack } from 'chakra-v3';

interface UserComponentRendererProps {
  node: ComponentNode<NgGenericTask[string]>;
  controller: TaskExecutionController | null;
  isCurrent: boolean;
}

/**
 * Stage 2 Renderer: Routes USER components by dtype
 */
export const UserComponentRenderer: React.FC<UserComponentRendererProps> = ({ node, controller, isCurrent }) => {
  const dtype = 'dtype' in node.component ? node.component.dtype : 'UNKNOWN';
  const Component = UserComponentRendererConfig[dtype] as React.ComponentType<ComponentRendererProps>;

  if (!Component) {
    return <UnsupportedComponentRenderer node={node} controller={controller} isCurrent={isCurrent} />;
  }

  return (
    <VStack w="100%" align="stretch" gap="16px">
      <Component node={node} controller={controller} isCurrent={isCurrent} />
      {isCurrent && <SubmitTaskButton controller={controller} />}
    </VStack>
  );
};
